import moment from 'moment';
import { arrayToStr, stringToArray } from '@utils/misc';
import { isValidDate } from '@utils/date';

export const ADDON_TITLES = {
  'laundry-clean': 'Fold Laundry',
  'fridge-clean': 'Clean Fridge',
  'oven-clean': 'Scrub Oven',
  'window-clean': 'Interior Windows',
  'mopping-clean': 'Mop floors'
};

export const DAYS = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday'
};

const TRANSFORM_KEYS = {
  propertyID: 'key',
  propertyID1: 'key',
  officeID: 'key',
  regionID: 'key',
  userID: 'key',
  userID1: 'key',
  userID2: 'key'
};

export const transformAddonKeyToTitle = addonKey => {
  return ADDON_TITLES[addonKey];
};

export const transformAddonTitleToKey = addonTitle => {
  return Object.keys(ADDON_TITLES).find(
    addonKey => ADDON_TITLES[addonKey] === addonTitle
  );
};

function transformKeyValue(key, val) {
  const propKey = TRANSFORM_KEYS[key];
  if (typeof val === 'object' && val !== null && !!propKey) {
    return val[propKey];
  } else if (typeof val !== 'object' || !!val) {
    return val;
  }
}

export const deserializeParams = filterObj => {
  if (!filterObj) {
    return filterObj;
  }

  const newFilter = {};
  Object.keys(filterObj).forEach(key => {
    const filterVal = filterObj[key];

    if (Array.isArray(filterVal)) {
      newFilter[key] = filterVal.map(item => transformKeyValue(key, item));
    } else {
      newFilter[key] = transformKeyValue(key, filterVal);
    }
  });

  return newFilter;
};

export const transformStripePrice = price => {
  const newPrice = price / 100;
  if (isNaN(newPrice)) {
    return 0;
  }
  return newPrice.toFixed(2);
};

export const transformMinToHr = min => {
  const hr = Math.floor(min / 60);
  const mins = min % 60;

  let result = '';

  if (hr) {
    result += hr + 'h ';
  }

  if (mins) {
    result += mins + 'm ';
  }
  return result;
};

export const transformPropertyToApiRequest = (refValues, values) => {
  const { city } = refValues;
  const {
    serviceAvailability,
    region: oldRegion,
    regionHours,
    office,
    regionID,
    buildingsNames,
    isBuildingRequired,
    keyReleaseEmail,
    scheduleEmail,
    activeAt,
    ...restValues
  } = values;

  const splits = city.split('_');

  return {
    ...refValues,
    ...restValues,
    city: splits[0],
    activeAt: isValidDate(activeAt) ? activeAt : undefined,
    keyReleaseEmail: arrayToStr(keyReleaseEmail),
    scheduleEmail: arrayToStr(scheduleEmail),
    regionID: regionID,
    isBuildingRequired: !!isBuildingRequired,
    buildingsNames: isBuildingRequired ? buildingsNames : []
  };
};

export const transformPropertyApiResponse = (
  property,
  currentData,
  allOffices,
  allRegions
) => {
  const {
    name,
    address,
    city,
    state,
    zipcode,
    isBuildingRequired,
    buildingsNames,
    bedroomsCounts,
    unitsCount,
    status,
    activeAt,
    keyRelease,
    keyReleaseEmail,
    firstDayOfService,
    regionHours,
    scheduleEmail,
    regionID
  } = property;

  let { office, region } = property;

  if (!office || !region) {
    region = allRegions.find(item => item.regionID === regionID);
    office = allOffices.find(item => item.officeID === region.officeID);
  }

  const basicInfo = {
    name,
    address,
    city: `${city}_${state}`,
    state,
    zipcode,
    isBuildingRequired,
    buildingsNames,
    bedroomsCounts,
    unitsCount
  };

  const serviceInfo = {
    status,
    activeAt: moment(activeAt),
    office: {
      key: office.officeID,
      label: office.name
    },
    region,
    keyRelease,
    keyReleaseEmail: stringToArray(keyReleaseEmail),
    scheduleEmail: stringToArray(scheduleEmail),
    firstDayOfService: moment(firstDayOfService),
    serviceAvailability: [],
    regionHours,
    regionID
  };

  return { basicInfo, serviceInfo };
};
